export enum WidgetType {
  Accordion = 'Accordion',
  Audio = 'Audio',
  BlockTitle = 'BlockTitle',
  Carousel = 'Carousel',
  Card = 'Card',
  CardSection = 'CardSection',
  ClozeQuestion = 'ClozeQuestion',
  CombinedTitle = 'CombinedTitle',
  ContentArea = 'ContentArea',
  Embed = 'Embed',
  EnclosureWithBlockTitle = 'EnclosureWithBlockTitle',
  EnclosureWithCombinedTitle = 'EnclosureWithCombinedTitle',
  EvaluatablePlugin = 'EvaluatablePlugin',
  FillInTheBlanksQuestion = 'FillInTheBlanksQuestion',
  FlexSection = 'FlexSection',
  Hotspot = 'Hotspot',
  HotspotQuestion = 'HotspotQuestion',
  Image = 'Image',
  InteractiveVideo = 'InteractiveVideo',
  InteractivePoll = 'InteractivePoll',
  InteractiveQuiz = 'InteractiveQuiz',
  MicrosoftEmbed = 'MicrosoftEmbed',
  OpenDiscussion = 'OpenDiscussion',
  OpenQuestion = 'OpenQuestion',
  Page = 'Page',
  PdfDocument = 'PdfDocument',
  Plugin = 'Plugin',
  QuestionGroupList = 'QuestionGroupList',
  Section = 'Section',
  SelectionQuestion = 'SelectionQuestion',
  Slide = 'Slide',
  SortQuestion = 'SortQuestion',
  Spacer = 'Spacer',
  StyledBulletList = 'StyledBulletList',
  Table = 'Table',
  Text = 'Text',
  UnifiedVideo = 'UnifiedVideo',
  Video = 'Video',
  YesNoQuestion = 'YesNoQuestion'
}

export enum EvaluationMode {
  Auto = 'auto',
  Manual = 'manual'
}

export const evaluatableWidgets = [
  WidgetType.SelectionQuestion,
  WidgetType.SortQuestion,
  WidgetType.ClozeQuestion,
  WidgetType.FillInTheBlanksQuestion,
  WidgetType.HotspotQuestion,
  WidgetType.EvaluatablePlugin,
  WidgetType.QuestionGroupList,
  WidgetType.InteractiveQuiz,
  WidgetType.YesNoQuestion
] as const;

export const flexibleWidgets = [
  WidgetType.FlexSection,
  WidgetType.Card,
  WidgetType.CardSection,
  WidgetType.SelectionQuestion,
  WidgetType.ClozeQuestion,
  WidgetType.OpenQuestion,
  WidgetType.FillInTheBlanksQuestion,
  WidgetType.InteractivePoll,
  WidgetType.InteractiveQuiz,
  WidgetType.QuestionGroupList,
  WidgetType.SortQuestion,
  WidgetType.EvaluatablePlugin
] as const;

export const isFlexibleWidget = (widgetType: unknown) => {
  return flexibleWidgets.includes(widgetType as (typeof flexibleWidgets)[number]);
};
// TODO: Make it possibe to evaluate OpenQuestion
export const scorableWidgets = [...evaluatableWidgets, WidgetType.OpenQuestion];

export const questionWidgets = [
  // Note: When extending, include the name in the QuestionGroupList -> QuestionBank -> locales
  WidgetType.ClozeQuestion,
  WidgetType.EvaluatablePlugin,
  WidgetType.FillInTheBlanksQuestion,
  WidgetType.HotspotQuestion,
  WidgetType.OpenQuestion,
  WidgetType.SelectionQuestion,
  WidgetType.SortQuestion,
  WidgetType.YesNoQuestion
];

export const collaborativeWidgets = [WidgetType.InteractivePoll, WidgetType.InteractiveQuiz, WidgetType.OpenDiscussion];

export const fullPageItems = [WidgetType.OpenDiscussion];

export const uniqueItemsPerPage = [WidgetType.OpenDiscussion, WidgetType.InteractivePoll, WidgetType.InteractiveQuiz];

export type EvaluatableWidgets = (typeof evaluatableWidgets)[number];

const isInArray = <T, A extends T>(item: T, array: ReadonlyArray<A>): item is A => array.includes(item as A);

export const canHaveScoreWeight = (widgetType: unknown) => {
  return isInArray(widgetType, scorableWidgets);
};

export const widgetsWithConfig = [
  WidgetType.Accordion,
  WidgetType.Audio,
  WidgetType.BlockTitle,
  WidgetType.Card,
  WidgetType.Carousel,
  WidgetType.ClozeQuestion,
  WidgetType.CombinedTitle,
  WidgetType.Embed,
  WidgetType.EnclosureWithBlockTitle,
  WidgetType.EnclosureWithCombinedTitle,
  WidgetType.EvaluatablePlugin,
  WidgetType.FillInTheBlanksQuestion,
  WidgetType.Hotspot,
  WidgetType.HotspotQuestion,
  WidgetType.Image,
  WidgetType.InteractivePoll,
  WidgetType.InteractiveQuiz,
  WidgetType.InteractiveVideo,
  WidgetType.MicrosoftEmbed,
  WidgetType.OpenQuestion,
  WidgetType.PdfDocument,
  WidgetType.Plugin,
  WidgetType.QuestionGroupList,
  WidgetType.SelectionQuestion,
  WidgetType.SortQuestion,
  WidgetType.StyledBulletList,
  WidgetType.Table,
  WidgetType.Text,
  WidgetType.Video
];
